import { render } from "./Situation.vue?vue&type=template&id=68565631&scoped=true"
import script from "./Situation.vue?vue&type=script&lang=js"
export * from "./Situation.vue?vue&type=script&lang=js"

import "./Situation.vue?vue&type=style&index=0&id=68565631&lang=scss"
import "./Situation.vue?vue&type=style&index=1&id=68565631&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68565631"]])

export default __exports__